import React, { Component } from 'react';
import LoginForm from './credentials/LoginForm';
import SignupForm from './credentials/SignupForm';
import PasswordResetForm from './credentials/PasswordResetForm';
import RecoverPasswordForm from './credentials/RecoverPasswordForm';

import '../../css/Credentials.css';

class Credentials extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      form: props.form || 'login',
      show: props.show,
      onClose: props.onClose
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({show: newProps.show, form: newProps.form});
  }

  onFormChange(form, evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    this.setState({form});
  }

  render() {

    if (!this.state.show)
      return null;

    return (

      <div id="credentials">
        { this.state.form === 'login' && <LoginForm onClose={this.state.onClose} onFormChange={this.onFormChange.bind(this)}/> }
        { this.state.form === 'register' && <SignupForm onClose={this.state.onClose} onFormChange={this.onFormChange.bind(this)}/> }
        { this.state.form === 'password_reset' && <PasswordResetForm onClose={this.state.onClose} onFormChange={this.onFormChange.bind(this)}/> }
        { this.state.form === 'recover' && <RecoverPasswordForm onClose={this.state.onClose} onFormChange={this.onFormChange.bind(this)}/> }
      </div>
    );
  }

}

export default Credentials;



// WEBPACK FOOTER //
// ./src/js/components/Credentials.jsx